<template>
	<div class="bx-page welcome">
		<div class="centered mw-narrow">

            <div class="login_header">
                <a :href="provider.subscriber_home_url" >
                    <img :src="provider.subscriber_logo_url" :alt="provider.name" >
                </a>
            </div>

			<div class="bx-border">
				<h1>Log in</h1>
				<LoginForm :to="{name:'home'}" :providerId="provider.id"/>
			</div>
		</div>
	</div>
</template>


<script>

	import { unref } from "vue";
	import useAuthStore from "../../stores/AuthStore";
	import LoginForm from "../../components/LoginForm";
    import useActiveProviderStore from '../../stores/ActiveProviderStore';

	export default {

		components:{
			LoginForm,
		},

        setup(){
			var {provider} = useActiveProviderStore();

            return {
                provider,
            }
        },

		beforeRouteEnter (to, from, next) {
			var {is_logged_in,user} = useAuthStore();
            if(unref(is_logged_in)){
				next(to.query.redirect||{name:'home'});
			} else {
				next();
			}
		},

	}
</script>

<style lang="scss" scoped>
    .login_header{
        img{
            max-width:40%;
            max-height:3.5em;
            height: auto;
            width:auto;
        }
        margin-bottom:2em;
    }
</style>
